'use client';

import { useLandingLanguage } from '@/hooks/useLandingLanguage';
import { cadrinoCopy, type CadrinoCopy } from './copy';

export function useCadrinoCopy(): CadrinoCopy {
  const { language } = useLandingLanguage();
  return cadrinoCopy[language === 'en' ? 'en' : 'sr'];
}
